import React from 'react';
import Header from '../Components/Header';
import HeroSection from '../Components/HeroSection';
import AboutSection from '../Components/AboutSection';
import PortfolioSection from '../Components/PortfolioSection'
import ServicesSkillsSection from '../Components/ServicesSkillsSection';
import TestimonialsSection from '../Components/TestimonialsSection';
import CTASection from '../Components/CTASection';
import Experience from '../Components/Experience'
import Contact from '../Components/Contact'
import BlogSection from '../Components/BlogSection'
import Footer from '../Components/Footer'

function Home() {
    return (
        <div>
            <Header />
            <HeroSection />
            <AboutSection />
            <PortfolioSection />
            <ServicesSkillsSection />
            <TestimonialsSection />
            <Experience />
            <CTASection />
            <BlogSection />
            <Contact />
            <Footer />
        </div>
    );
}

export default Home;
